class StatesAndProvinces {
    static usNames = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District of Columbia",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming",
    }

    static caNames = {
        "AB": "Alberta",
        "BC": "British Columbia",
        "MB": "Manitoba",
        "NB": "New Brunswick",
        "NL": "Newfoundland and Labrador",
        "NT": "Northwest Territories",
        "NS": "Nova Scotia",
        "NU": "Nunavut",
        "ON": "Ontario",
        "PE": "Prince Edward Island",
        "QC": "Quebec",
        "SK": "Saskatchewan",
        "YT": "Yukon Territory",
    }

    static names = {
        ...this.usNames,
        ...this.caNames,
    }

    // static validate($search, $type = 'any', $return_detail = false) {
    //     foreach(this.$names as $abbrev: $name) {
    //         $found = false

    //         // search full names
    //         if (($type == 'name' || $type == 'any') && strtoupper($name) == strtoupper($search)) {
    //             $found = true
    //         }

    //         // search abbrevs
    //         if (($type == 'abbrev' || $type == 'any') && strtoupper($abbrev) == strtoupper($search)) {
    //             $found = true
    //         }

    //         if ($found) {
    //             if ($return_detail) {
    //                 return [
    //                     'name': $name,
    //                     'abbrev': $abbrev,
    //                 ]
    //             } else {
    //                 return true
    //             }
    //         }
    //     }

    //     return false
    // }

    // static function convert_name_to_abbrev($name) {
    //     $result = self:: validate($name, 'name', true)

    //     if ($result) {
    //         return $result['name']
    //     } else {
    //         return false
    //     }
    // }

    // static function convert_abbrev_to_name($abbrev) {
    //     $result = self:: validate($abbrev, 'abbrev', true)

    //     if ($result) {
    //         return $result['abbrev']
    //     } else {
    //         return false
    //     }
    // }
}

export default StatesAndProvinces
